import { useState } from "react";
import { useLocation } from "react-router-dom";

const RewardBanner = ({ userdata, bonusPoints = 100 }) => {
  const [visible, setVisible] = useState(true);
  const location = useLocation();

  if (location.pathname !== "/" || userdata !== null || !visible) {
    return null;
  }

  return (
    <>
      <style>{`
        @keyframes reward-bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
        .reward-emoji {
          display: inline-block;
          animation: reward-bounce 2s infinite ease-in-out;
          font-size: 20px;
          margin-right: 4px;
        }
        .reward-close-btn:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          transform: translateY(-50%) scale(1.1) !important;
        }
        @media (max-width: 768px) {
          .reward-content-wrapper {
            flex-direction: column !important;
            gap: 4px !important;
            padding-right: 30px !important;
          }
          .reward-text-container {
            flex-direction: column;
            gap: 2px !important;
            align-items: center;
          }
          .reward-desc {
            font-size: 12px !important;
            text-align: center;
          }
          .reward-title {
            font-size: 13px !important;
            text-align: center;
          }
        }
      `}</style>
      <div style={styles.wrapper}>
        <div className="reward-content-wrapper" style={styles.content}>
          <span className="reward-emoji">🎉</span>
          <div className="reward-text-container" style={styles.textContainer}>
            <span className="reward-title" style={styles.title}>Get Rewarded Instantly!</span>
            <span className="reward-desc" style={styles.desc}>
              Register now and get {" "}
              <span style={styles.highlight}>
                {bonusPoints} bonus points
              </span>{" "}
              in your wallet.
            </span>
          </div>
        </div>
        <button 
          onClick={() => setVisible(false)} 
          className="reward-close-btn"
          style={styles.closeBtn}
          title="Close Banner"
        >
          ✖
        </button>
      </div>
    </>
  );
};

export default RewardBanner;

const styles = {
  wrapper: {
    width: "100%",
    background: "#b92200",
    boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
    padding: "10px 16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: 10000,
    color: "#fff",
    fontFamily: "'Segoe UI', Roboto, sans-serif",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    width: "100%",
    maxWidth: "1200px",
  },
  textContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  title: {
    fontWeight: "700",
    fontSize: "14px",
    letterSpacing: "0.2px",
  },
  desc: {
    fontSize: "13.5px",
    opacity: 1,
  },
  highlight: {
    fontWeight: "800",
    background: "rgba(255, 255, 255, 0.25)",
    padding: "2px 8px",
    borderRadius: "4px",
    fontSize: "12.5px",
    border: "1px dashed rgba(255, 255, 255, 0.5)",
    color: "#ffffff",
    display: "inline-block",
  },
  closeBtn: {
    position: "absolute",
    right: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(255,255,255,0.15)",
    border: "none",
    borderRadius: "50%",
    width: "26px",
    height: "26px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "11px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s ease, transform 0.2s ease",
    outline: "none",
  },
};
